module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"cs":{"FittingGuideModal":{"emptyContent":"Pro tento produkt není tabulka velikostí nastavena."}}}')
  delete Component.options._Ctor
}
